export default __webpack_public_path__ + "static/media/medals3.b0a0e5cb.svg";